// extracted by mini-css-extract-plugin
export default {"container":"HtmlCss_container__TUsEc","cards":"HtmlCss_cards__Go-jG","card":"HtmlCss_card__N+qN6","img":"HtmlCss_img__2P6mc","text":"HtmlCss_text__8pK4D","src":"HtmlCss_src__Jpn1I"};